/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from "flickity";
require('flickity-as-nav-for');
require("flickity-sync");
require('flickity-fade');

 
class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.primaryCarouselElem = self.elem.querySelector('[data-primary-carousel]');
        self.secondaryCarouselElem = self.elem.querySelector('[data-secondary-carousel]');
    }

    init() {
        let self = this;

        self.initCarousels();
    }

    initCarousels() {
        let self = this;

        const flktyPrimary = new Flickity(self.primaryCarouselElem, {
            
            contain: true,

            pageDots: false,
            prevNextButtons: true,
            wrapAround: true,
            percentPosition: false,  
            
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 65, y2: 45,
                x3: 20
              }
              
            });

        
        const flktySecondary = new Flickity(self.secondaryCarouselElem, {
            sync: self.primaryCarouselElem,
            contain: true,
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true,
            fade: true,
            autoPlay: 5000


        });
        
    }

}

export default Carousel;